<template>
  <div class="table-wrapper" id="unitsTable">
    <vs-input
        class="search"
        type="search"
        v-model="search"
        placeholder="Search..."
    />
    <v-simple-table
        fixed-header
    >
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">
            <div class="header-item-wrapper">
              <span class="header-label">
                Lot
              </span>
              <span class="header-sort" :class="sortBy==='lot'?'active':''" v-on:click="changeSortByToLot"
              >
                <font-awesome-icon icon="sort-down" v-if="sortBy==='lot'"/>
                <font-awesome-icon icon="sort" v-if="sortBy==='closingDate'"/>
              </span>
            </div>
          </th>
          <th class="text-left">
            <div class="header-item-wrapper">
              <span class="header-label">
                Buyer Closing Date
              </span>
              <span class="header-sort" :class="sortBy==='closingDate'?'active':''"
                    v-on:click="changeSortByToClosingDate">
                <font-awesome-icon icon="sort-down" v-if="sortBy==='closingDate'"/>
                <font-awesome-icon icon="sort" v-if="sortBy==='lot'"/>
              </span>
            </div>
          </th>
          <th class="text-left">
            <div class="header-item-wrapper">
              <span class="header-label">Status</span>

              <div class="status-checkboxes">
                <vs-tooltip>
                  <vs-checkbox class="checkbox-due"
                               val="due"
                               v-model="options" color="#ffd166">
                  </vs-checkbox>
                  <template #tooltip>
                    <div class="content-tooltip">
                      Due Today
                    </div>
                  </template>
                </vs-tooltip>
                <vs-tooltip>
                  <vs-checkbox class="checkbox-pastdue"
                               val="pastdue"
                               v-model="options" color="#ef476f">
                  </vs-checkbox>
                  <template #tooltip>
                    <div class="content-tooltip">
                      Past due
                    </div>
                  </template>
                </vs-tooltip>
                <vs-tooltip>
                  <vs-checkbox class="checkbox-safe"
                               val="safe"
                               v-model="options" color="#06d6a0">
                  </vs-checkbox>
                  <template #tooltip>
                    <div class="content-tooltip">
                      Not due
                    </div>
                  </template>
                </vs-tooltip>
              </div>
            </div>
          </th>
          <th class="text-left">
            <div class="header-item-wrapper">
              <vs-tooltip>
                <font-awesome-icon icon="question-circle"/>
                <template #tooltip>
                  <div class="content-tooltip">
                    <h4>
                      Note
                    </h4>
                    <p>
                      For the task names that are in <span class="green-color-span">Green</span>, their most recent
                      incomplete task is ['In progress']
                    </p>
                  </div>
                </template>
              </vs-tooltip>
              <span class="header-label">Task</span>
            </div>
          </th>
          <th class="text-left">
            Start Date
          </th>
          <th class="text-left">
            End Date
          </th>
        </tr>
        </thead>
        <tbody>
          <tr class="table-body-row" v-for="(unit,i) in unitsData" :key="i">
            <td class="table-body-item">
              {{ unit.Name }}
            </td>
            <td class="table-body-item">
              {{ formatDate(unit['Buyer Closing Date']) }}
            </td>
            <td class="table-body-item"
                 :class="getBufferClassByColor(getTheCorrectSchedule(unit.ScheduleInfo)['Buffer'])">
              <div class="buffer-wrapper">
                <div class="buffer-cell">
                  {{ getTheCorrectSchedule(unit.ScheduleInfo)['Buffer'] }}
                </div>
              </div>
            </td>
            <td class="table-body-item">
              <div class="body-item-wrapper">
                <vs-button
                    border
                    :color="getBorderColorOfTask(getTheCorrectSchedule(unit.ScheduleInfo))"
                    :active="true"
                    @click="clickTask"
                    class="task-name-button"
                >
                  {{
                    getTheCorrectSchedule(unit.ScheduleInfo).Incomplete['Schedule Live Task'] ? getTheCorrectSchedule(unit.ScheduleInfo).Incomplete['Schedule Live Task'] : 'N/A'
                  }}
                </vs-button>
                <ExtrasTooltip :unitID="unit.ID.toString().toLowerCase()"
                               :scheduleLiveAreaTaskID="getTheCorrectSchedule(unit.ScheduleInfo).Incomplete.ID.toString()"></ExtrasTooltip>
              </div>
            </td>
            <td class="table-body-item">
              <vs-button
                  border
                  :color="getBorderColorOfDate(getTheCorrectSchedule(unit.ScheduleInfo).Incomplete['Start Date'])"
                  :active="true"
                  @click="clickStartDate"
                  class="start-date-button"
              >
                {{ formatDate(getTheCorrectSchedule(unit.ScheduleInfo).Incomplete['Start Date']) }}
              </vs-button>

            </td>
            <td class="table-body-item">

              <vs-button

                  border
                  :color="getBorderColorOfDate(getTheCorrectSchedule(unit.ScheduleInfo).Incomplete['End Date'])"
                  :active="true"
                  @click="clickEndDate"
                  class="end-date-button"
              >
                {{
                  formatDate(getTheCorrectSchedule(unit.ScheduleInfo).Incomplete['End Date']) ? formatDate(getTheCorrectSchedule(unit.ScheduleInfo).Incomplete['End Date']) : 'N/A'
                }}
              </vs-button>
            </td>
          </tr>

        </tbody>
      </template>
    </v-simple-table>
    <div class="loader" v-if="!unitsData.length">
      <img class="loader-img" alt="Loading" src="@/assets/loading.svg">
    </div>
  </div>
</template>

<script>

// import vueCustomScrollbar from 'vue-custom-scrollbar'
import ExtrasTooltip from "@/components/ExtrasTooltip";
import moment from 'moment'

export default {
  name: 'UnitsTable',
  props: {
    units: Array
  },
  mounted() {
    // console.log('units', this.units)
  },

  data: function () {
    return {
      search: '',
      settings: {
        suppressScrollY: false,
        suppressScrollX: true,
        wheelPropagation: false
      },
      options: [
        'due',
        'pastdue',
        'safe'
      ],
      sortBy: 'lot'
    };
  },
  watch: {
    options: function (options) {
      console.log('options:', options)
    }
  },
  components: {
    // vueCustomScrollbar,
    ExtrasTooltip
  },
  computed: {
    unitsData: function () {
      let _this = this;
      let unitsData = this.units
      if (_this.sortBy === 'closingDate') {

        unitsData.sort(function (a, b) {
          let keyA = moment(a['Buyer Closing Date']),
              keyB = moment(b['Buyer Closing Date']);
          // Compare the 2 dates
          // console.log('keyA', keyA, 'keyB', keyB)
          if (keyA.isBefore(keyB)) {
            return -1;
          }
          if (keyA.isAfter(keyB)) {
            return 1;
          }
          return 0;
        });
      } else if (_this.sortBy === 'lot') {
        unitsData.sort(function (a, b) {
          let keyA = a.Name,
              keyB = b.Name;
          // Compare the 2 dates
          // console.log('keyA', keyA, 'keyB', keyB)
          if (keyA < keyB) {
            return -1;
          }
          if (keyA > keyB) {
            return 1;
          }
          return 0;
        });
      }


      return unitsData.filter(function (e) {
        // console.log('e:', e)
        let matchStatusOptions = true
        let matchStatusCode = ''
        if (e.ScheduleInfo){
          if (e.ScheduleInfo.length){

            let buffer = _this.getTheCorrectSchedule(e.ScheduleInfo)['Buffer']
            if (parseInt(buffer) === 0) {
              matchStatusCode = 'due'
              matchStatusOptions = !!_this.options.includes(matchStatusCode);
            } else if (parseInt(buffer) > 0) {
              matchStatusCode = 'safe'
              matchStatusOptions = !!_this.options.includes(matchStatusCode);
            } else if (parseInt(buffer) < 0) {
              matchStatusCode = 'pastdue'
              matchStatusOptions = !!_this.options.includes(matchStatusCode);
            }

            if (_this.getTheCorrectSchedule(e.ScheduleInfo).Incomplete){
              // console.log('matchStatusOptions', matchStatusOptions, 'e', e)
              let taskName = _this.getTheCorrectSchedule(e.ScheduleInfo).Incomplete['Schedule Live Task']
              // console.log('taskName', taskName)
              return (e.Name.toLowerCase().includes(_this.search.toLowerCase()) || taskName.toLowerCase().includes(_this.search.toLowerCase())) && matchStatusOptions;
            }
            else{
              return false
            }


          }
          else{
            return false;
          }
        }
        else{
          return false;
        }

      });
    },

  },
  methods: {

    getBufferClassByColor: function (buffer) {
      if (parseInt(buffer) === 0) {
        return 'buffer-today';
      } else if (buffer > 0) {
        return 'buffer-above';
      } else if (buffer < 0) {
        return 'buffer-below';
      } else {
        return 'buffer-default';
      }
    },
    getTheCorrectSchedule(taskSchedules) {
      // console.log('taskSchedule', taskSchedules)
      let machingSchedule = taskSchedules[0]
      if (taskSchedules.length > 1) {
        taskSchedules.forEach(schedule => {
          // console.log(schedule.Name)
          if (!schedule.Name.includes('status')) {
            machingSchedule = schedule
          }
        })
      } else {
        machingSchedule = taskSchedules[0]

      }
      // console.log('matchingSchedule', machingSchedule)
      return machingSchedule

    },
    clickTask() {
      console.log('clicked task')
    },
    clickStartDate() {
      console.log('clicked clickStartDate')
    },
    clickEndDate() {
      console.log('clicked clickEndDate')
    },
    getBorderColorOfTask(schedule) {
      // console.log('getColorOfTask schedule', schedule)
      if (schedule.Incomplete.Status === 'In progress') {
        return "#06d6a0"
      } else {
        return "#000000"
      }
    },
    getBorderColorOfDate(date) {
      let todayMoment = moment()
      let formattedDate = this.formatDate(date)
      if (formattedDate) {
        let formattedDateMoment = moment(formattedDate)

        let diff = todayMoment.diff(formattedDateMoment, 'days')
        if (diff < 0) {
          return "#06d6a0"
        } else if (diff > 0) {
          return "#ef476f"
        } else {
          return "#ffd166"
        }

      } else {
        return "#000000"
      }
    },
    formatDate(originalDate) {
      let formattedDate = '';
      if (originalDate) {
        let trimmedOriginalDate = originalDate.replace('Mon', '').replace('Tue', '').replace('Wed', '').replace('Thu', '').replace('Fri', '').replace('Sat', '').replace('Sun', '')
        formattedDate = moment(trimmedOriginalDate).format('MMM DD, YYYY');
      }
      return formattedDate;
    },
    changeSortByToLot() {
      this.sortBy = 'lot'
    },
    changeSortByToClosingDate() {
      this.sortBy = 'closingDate'
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">

.table-wrapper#unitsTable
  .search
    padding: 2em 0 2em
    +mobile
      padding: 2em 0 1em

    .vs-input
      background-color: rgba(gray, 0.1)

      border: 2px solid black
      color: black

    .vs-input__label.vs-input__label--label
      font-size: 1.2em
      margin-bottom: 0.5em
  .v-data-table__wrapper
    max-height: calc(100% - 81px - 93px - 1em)
  .table
    width: 100%
    border-collapse: collapse

  thead
    background-color: rgba(gray, 0.1)
    border-width: 0 1px 0 1px
    padding: 0.5em 0
    tr
      th
        font-weight: bold
        font-size: 1em !important
        color: black !important
        text-align: left
        padding: 0.5em
        +mobile
          font-size: 0.85em !important
          white-space: nowrap


        .header-item-wrapper
          display: flex
          flex-direction: row
          align-items: center

          .header-sort
            cursor: pointer
            opacity: 0.5

            &.active
              opacity: 1
              pointer-events: none

          svg
            margin: 0 0.25em

          .status-checkboxes
            display: flex
            flex-direction: row
            margin-left: 0.5em

            .vs-checkbox-content
              margin: 0 0.25em

              &.checkbox-due
                .vs-checkbox-mask:before
                  background-color: $Neutral
                  opacity: 0.8

              &.checkbox-pastdue
                .vs-checkbox-mask:before
                  background-color: $Warning
                  opacity: 0.8

              &.checkbox-safe
                .vs-checkbox-mask:before
                  background-color: $Safe
                  opacity: 0.8

  tbody

    width: 100%

    .table-body-row
      flex-direction: row
      border: 1px solid rgba(black, 0.1)
      border-width: 1px 0 0 0
      align-items: center

    .table-body-item
      font-size: 1em
      font-weight: 500
      border: 1px solid transparent
      border-width: 0 1px 0 1px
      padding: 0.5em
      text-align: left
      white-space: nowrap
      +mobile
        font-size: 0.85em !important
      .start-date-button,.end-date-button
        white-space: nowrap
      .body-item-wrapper
        display: flex
        flex-direction: row
        align-items: center

        .task-name-button
          max-width: 300px
          min-width: 200px

          .vs-button__content
            padding-left: 1em
            padding-right: 1em

        .extra-indicator
          padding: 0.1em 0.5em
          border-radius: 12px
          background-color: $Main
          color: white
          z-index: 1
          cursor: help



      &[class*=buffer-]
        .buffer-wrapper
          display: flex
          flex-direction: column
          text-align: center
          justify-content: center
          align-items: center
          border-radius: 12px
          background-color: #1e1e1e
          color: white
          width: 2.5em
          height: 2.5em

          .buffer-cell
            font-weight: bold
            padding-top: 0.1em

        &.buffer-today
          .buffer-wrapper
            background-color: $Neutral

        &.buffer-above
          .buffer-wrapper
            background-color: $Safe

        &.buffer-below
          .buffer-wrapper
            background-color: $Warning

      .vs-button__content
        font-weight: bold
        color: white

.loader
  margin: 2em

  img
    width: 60px
    height: 60px


.list-enter-active, .list-leave-active
  transition: all 0.3s

.list-enter, .list-leave-to
  opacity: 0
  transform: translateX(-10px)
</style>
